import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

export class WbSearchController {
  constructor() {
    this.ignoredParams = ['action', 'siteId', 'X-CSRF-Token', 'template', 'globalSearchIndex'];
    this.pagination = false;
    this.loading = false;
    this.init();
    this.addInfiniteScroll();
  }

  init() {
    return new Promise((resolve) => {
      this.bindListeners();

      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document.addEventListener('_page_loaded', _this.addInfiniteScroll.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener(
        'change',
        '.wb-search-filters__select--force, .wb-search-filters__radio--force, #sort-by',
        _this.selectFilter.bind(_this),
      );

    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.wb-search-filters__submit, .wb-search-filters__submit--keywords',
        _this.submitForm.bind(_this),
      );

    document.querySelector('body')._addCustomEventListener('click', '.js-load-more', _this.loadMoreResults.bind(_this));
  }

  loadMoreResults(e) {
    if (e) e.preventDefault();
    if (this.loading) return;

    const target = e.target;

    this.loading = true;
    this.container = target.closest('.wb-search-results-layout');

    const form = this.container.querySelector('.wb-search-filters__form');
    let pg = 0;

    if (this.container.classList.contains('wb-search-results-layout--numeric')) {
      this.pagination = true;
      pg = Number(e.targetElement.getAttribute('data-pg'));
    } else {
      const currentPg = form.querySelector('[name="pg"]').value;
      pg = Number(currentPg) + 1;
    }

    document.querySelectorAll('body').forEach((e) => e.classList.add('--locked'));
    form.querySelector('[name="pg"]').value = pg;

    this.setUrlParams(form);
    this.prepareAjax(form, true);
    this.doAjax();
  }

  selectFilter(e) {
    const target = e.target ? e.target : e;
    this.submitForm(target, false);
  }

  submitForm(e, prevent = true) {
    if (prevent) e.preventDefault();

    const target = e.target ? e.target : e;
    const form = target.closest('form') || document.querySelector('.wb-search-filters__form');

    this.setUrlParams(form);
    this.prepareAjax(form);
    this.doAjax();
  }

  setUrlParam(name, val) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.set(name, val);
    this.setHistoryState(url);
  }

  delUrlParam(name) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.delete(name);
    this.setHistoryState(url);
  }

  setUrlParams(form) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const formData = new FormData(form);
    const paramsRef = Array.from(params.entries());
    const sortBy = document.querySelector('#sort-by');

    for (const d of paramsRef) {
      params.delete(d[0]);
    }

    for (const d of formData.entries()) {
      if (this.ignoredParams.includes(d[0])) continue;
      params.append(d[0], d[1]);
      if (d[0] != 's' && d[1] == '') params.delete(d[0]);
    }

    if (sortBy && sortBy.value) params.append(sortBy.name, sortBy.value);

    this.setHistoryState(url);
  }

  setHistoryState(url) {
    history.replaceState(null, '', url.href);
  }

  prepareAjax(form, paginate = false) {
    this.container = form.closest('.wb-search-results-layout');

    const sortBy = this.container.querySelector('#sort-by');
    const data = new FormData(form);

    if (!paginate) {
      this.delUrlParam('pg');
      this.filter = true;
      form.querySelector('[name="pg"]').value = 1;
      data.set('pg', 1);
    }
    if (sortBy) data.append(sortBy.name, sortBy.value);

    this.data = data;
  }

  toggleAjaxOverlay() {
    const overlayIsActive = document.querySelector('#page').classList.contains('wb-load-overlay');

    if (!overlayIsActive) {
      const icon = document.createElement('div');
      icon.classList.add('wb-load-overlay__icon');

      document.querySelector('#page').classList.add('wb-load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.wb-load-overlay').classList.remove('wb-load-overlay');
      document.querySelectorAll('.wb-load-overlay__icon').forEach((icon) => icon._remove());
    }
  }

  doAjax() {
    const _this = this;
    const urlParams = new URLSearchParams(_this.data);

    this.toggleAjaxOverlay();

    fetch(`/api/template?${urlParams}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => {
        if (!response.ok) {
          this.toggleAjaxOverlay();
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.text())
      .then((data) => {
        const PARSER = new DOMParser();
        const DOC = PARSER.parseFromString(data, 'text/html');
        const currentLayout = this.container.querySelector('.wb-search-results');
        const layout = DOC.querySelector('.wb-search-results');
        const blocks = DOC.querySelectorAll('.wb-ajax-block');
        const count = DOC.querySelector('.wb-search-top-bar__count');
        const pagination = DOC.querySelector('.wb-search-pg');

        currentLayout.setAttribute('data-current-pg', layout.getAttribute('data-current-pg'));
        currentLayout.setAttribute('data-total-pg', layout.getAttribute('data-total-pg'));

        if (_this.filter || _this.pagination) _this.container.querySelectorAll('.wb-ajax-block')._remove();
        if (blocks.length) _this.container.querySelector('.wb-search-results__grid')._appendAll(blocks);

        const currentCount = _this.container.querySelector('.wb-search-top-bar__count');
        if (currentCount) currentCount.replaceWith(count);

        const currentPagination = _this.container.querySelector('.wb-search-pg');
        if (currentPagination) currentPagination.replaceWith(pagination);

        if (this.filter || _this.pagination) {
          const offset = WbScrollTo.getScrollOffset(_this.container);
          WbScrollTo.scrollTo({ element: _this.container, offset });
        }

        document.querySelectorAll('body').forEach((e) => e.classList.remove('--locked'));

        ScrollTrigger.refresh();
        _this.resetProps();
        _this.toggleAjaxOverlay();
      })
      .catch((error) => console.error(error));
  }

  addInfiniteScroll() {
    const _this = this;
    const { scroller } = window.WbAnimations;
    const container = document.querySelector('.wb-search-results-layout');

    if (container && container.classList.contains('wb-search-results-layout--infinite')) {
      scroller.addAnim({
        element: container,
        trigger: container,
        scrollTrigger: {
          start: 'top top',
          end: 'bottom bottom',
          onUpdate: (self) => {
            const progress = self.progress.toFixed(2);
            const layout = container.querySelector('.wb-search-results');
            const currentPg = parseInt(layout.getAttribute('data-current-pg'));
            const totalPg = parseInt(layout.getAttribute('data-total-pg'));

            if (progress >= 0.9 && self.direction === 1 && currentPg < totalPg && !this.loading) {
              _this.loadMoreResults();
            }
          },
        },
      });
    }
  }

  resetProps() {
    this.filter = false;
    this.container = false;
    this.loading = false;
    this.pagination = false;
  }
}
